<template>
  <v-main>
    <TabbedInterface
      class="clean maxh-1bar"
      ref="interface"
      title="Organização"
      :tabComponents="allTabComponents"
      :value="org"
      @reload="reload"
      orientation="vertical"
      prefTabKey="adminOrgHomeTab"
    >
      <template v-slot:sidebar-title>
        <SidebarHeaders :headers="headers" class="mt-1 pa-2" />
      </template>
    </TabbedInterface>
  </v-main>
</template>

<script>
import TabbedInterface from 'oderon-vue/cpts/tabbed-interface/TabbedInterface.vue'
import SidebarHeaders from 'oderon-vue/cpts/tabbed-interface/SidebarHeaders.vue'
import OrgConfigTab from './OrgConfigTab.vue'
import OrgGroupsTab from './OrgGroupsTab.vue'
import OrgVehiclesTab from './OrgVehiclesTab.vue'
// import OrgTripsTab from './ClientOverviewTab.vue'
import OrgUsersTab from './OrgUsersTab.vue'
import OrgProfilesTab from './OrgProfilesTab.vue'
import OrgOccursTab from './OrgOccursTab.vue'

import { Org } from '@/models'

export default {
  components: {
    TabbedInterface,
    SidebarHeaders
  },
  props: {
    code: { required: true }
  },
  data() {
    return {
      org: null
    }
  },
  watch: {
    code() {
      this.reload()
    }
  },
  computed: {
    allTabComponents() {
      return [
        OrgConfigTab,
        OrgGroupsTab,
        OrgVehiclesTab,
        OrgUsersTab,
        OrgProfilesTab,
        OrgOccursTab
      ]
    },

    headers() {
      if (this.org == null) return []

      let orgLabel = this.org.label || this.org.name

      let result = [
        { icon: 'mdi-domain', text: orgLabel, primary: true },
        // {
        //   icon: 'mdi-code-braces',
        //   text: this.org.name,
        //   action: '#' + this.org.id
        // },
        {
          icon: 'mdi-developer-board',
          text: (this.org.clientCount || 0) + ' módulos'
        }
      ]

      return result
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    reload() {
      this.$refs.interface.$loading(() => this.fetchData())
    },

    async fetchData() {
      let org = await Org.findById(this.code)
      org.usePost = !org.useQueue
      if (org.extraInfo == null) org.extraInfo = {}
      this.org = org

      this.$setTitle(org.label)
    }
  }
}
</script>
